// extracted by mini-css-extract-plugin
module.exports = {"PhoneNumber":"PhoneNumber__1QL6e"};